import * as date from '#root/ts/time/date.js';

export { date };
